import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=bc6ec3c2&scoped=true"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6ec3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6ec3c2')) {
      api.createRecord('bc6ec3c2', component.options)
    } else {
      api.reload('bc6ec3c2', component.options)
    }
    module.hot.accept("./refund.vue?vue&type=template&id=bc6ec3c2&scoped=true", function () {
      api.rerender('bc6ec3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data-agent/refund.vue"
export default component.exports